/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 *
 * Perfil en modal desde el hub post-login — cerrar vuelve al panel sin elegir sucursal.
 */
import React from 'react';
import { ProfileScreen } from '../../settings/screens/ProfileScreen';

export function HubAccountScreen() {
  return <ProfileScreen />;
}
